import { handleSort } from './utils';

/**
 * Tri-state table sort handler for Configuration list pages.
 * Cycles: ascend → descend → clear (null orderBy).
 */
export function handleConfigTableSort(
  { modelName, dispatch, orderBy, defaultOrderBy },
  pagination,
  filters,
  sorter,
) {
  const resolvedSorter = Array.isArray(sorter) ? sorter[0] : sorter;
  let finalSorter = resolvedSorter;

  if (resolvedSorter && resolvedSorter.columnKey && !resolvedSorter.order) {
    if (orderBy === null) {
      finalSorter = { ...resolvedSorter, order: 'ascend' };
    } else {
      const currentOrderBy = orderBy || defaultOrderBy;
      const [currentKey, currentOrder] = currentOrderBy.split(' ');
      if (resolvedSorter.columnKey === currentKey && currentOrder === 'desc') {
        dispatch({ type: `${modelName}/setOrderBy`, payload: null });
        return;
      }
    }
  }

  handleSort.call([modelName, dispatch], pagination, filters, finalSorter);
}
